export const AUTHENTICATE_USER = 'USER::AUTHENTICATE_USER';
export const REVOKE_USER = 'USER::REVOKE_USER';
export const USER_DETAILS = 'USER::DETAIL';
export const USER_INFO = 'USER::INFO';
export const USER_UPDATED = 'USER::UPDATED';



// WEBPACK FOOTER //
// ./src/reducers/user/constants.js